import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const ConfirmClabeContainer = styled(FlexContainer)`
  background-color: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_supersoft};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  gap: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  width: fit-content;
`;
